export const executeAtEndOfCallStack = (callback: () => void) => {
  setTimeout(callback);
}
